import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

import Loader from "../../components/loader";
import api from "../../services/api";

export default function TemplateList() {
  const [contractTemplates, setContractTemplates] = useState();
  const { businessUnit } = useSelector((state) => state.Auth);
  const navigate = useNavigate();

  const fetchContractTemplates = async () => {
    const query = {};
    if (businessUnit._id !== "ALL") query.business_unit_id = businessUnit._id;
    const { data, ok } = await api.post("/legal_document_template/search", query);
    if (!ok) return toast.error("Failed to load contract templates");
    setContractTemplates(data);
  };

  useEffect(() => {
    fetchContractTemplates();
  }, [businessUnit._id]);

  const handleCreate = async () => {
    if (businessUnit._id === "ALL") {
      return toast.error("Select a specific business unit to create a template");
    }
    const { data, ok } = await api.post("/legal_document_template", {
      name: "New Template",
      business_unit_id: businessUnit._id,
      business_unit_name: businessUnit.name,
    });
    if (!ok) return toast.error("Failed to create template");
    navigate(`/legal_document/templates/${data._id}`);
  };

  if (!contractTemplates) return <Loader size="small" />;

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <p>{contractTemplates.length} template{contractTemplates.length !== 1 ? "s" : ""}</p>
        <button onClick={handleCreate} className="px-3 py-1 rounded-md text-white bg-primary">
          New Template
        </button>
      </div>
      <div className="bg-white rounded-lg">
        <table className="min-w-full divide-y divide-gray-200 table-fixed">
          <thead>
            <tr className="border-b border-gray-300">
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">Name</th>
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">Category</th>
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">BU</th>
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">Updated</th>
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">Created</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {contractTemplates.map((c) => (
              <tr key={c._id} className="hover:bg-blue-50 cursor-pointer" onClick={() => navigate(`/legal_document/templates/${c._id}`)}>
                <td className="px-4 py-2 text-sm font-medium text-gray-600">{c.name || "Untitled"}</td>
                <td className="px-4 py-2 text-sm text-gray-500">{c.category || "-"}</td>
                <td className="px-4 py-2 text-sm text-gray-500">{c.business_unit_name || "-"}</td>
                <td className="px-4 py-2 text-sm text-gray-500">{new Date(c.updated_at).toLocaleDateString()}</td>
                <td className="px-4 py-2 text-sm text-gray-500">{new Date(c.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
